export default {"src":"/_next/static/image/public/images/ic_incomplete.a00ac078dc409699b82e6dc5be576a29.svg","height":17,"width":17};